import axios from '../config/axios';

const API_URL = '/summary-of-changes';

const summaryOfChangesService = {
  // Get summary of changes for a project
  getSummaryOfChanges: async (projectId, documentType = 'PROTOCOL') => {
    try {
      console.log('Fetching summary of changes for project:', projectId, 'documentType:', documentType);
      const response = await axios.get(`${API_URL}`, {
        params: { projectId, documentType }
      });
      console.log('Summary of changes response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching summary of changes:', error);
      throw error.response?.data || error.message;
    }
  },

  // Save or update summary of changes
  saveSummaryOfChanges: async (projectId, documentType, table) => {
    try {
      console.log('Saving summary of changes for project:', projectId, 'documentType:', documentType);
      console.log('Table data:', table);
      
      const response = await axios.post(`${API_URL}/save`, {
        projectId,
        documentType,
        table
      });
      
      console.log('Save summary of changes response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error saving summary of changes:', error);
      throw error.response?.data || error.message;
    }
  },

  // Delete summary of changes
  deleteSummaryOfChanges: async (projectId, documentType = 'PROTOCOL') => {
    try {
      console.log('Deleting summary of changes for project:', projectId, 'documentType:', documentType);
      const response = await axios.delete(`${API_URL}/${projectId}/${documentType}`);
      console.log('Delete summary of changes response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error deleting summary of changes:', error);
      throw error.response?.data || error.message;
    }
  }
};

export default summaryOfChangesService; 